import { useLocation, useNavigate, useRouteContext } from '@tanstack/react-router'

export type Impersonation = {
	name: string
	partyAccountId: string
	subscriptionId: string
	currentLoggedinUserId: string
}

export const encodeImpersonation = (impersonation?: Impersonation) => {
	if (!impersonation) return undefined
	return btoa(JSON.stringify({ ...impersonation, hostname: document.location.hostname }))
}
export const asQueryParam = (impersonation?: Impersonation) => {
	const encoded = encodeImpersonation(impersonation)
	return encoded ? { impersonation: encoded } : undefined
}
export const useImpersonation = () => useRouteContext({ from: '/_app', select: (ctx) => ctx.impersonation })
export const useImpersonationActions = () => {
	const navigate = useNavigate()
	const pathname = useLocation({ select: (loc) => loc.pathname })

	return {
		startImpersonating: async (subscriptionId: string) => {
			await navigate({ to: pathname, search: { impersonation: subscriptionId }, hash: true })
		},
		stopImpersonating: async () => {
			await navigate({ to: '/', search: { impersonation: undefined }, replace: true })
		},
	}
}
